<template>
    <div
        class="map-tab mg-scrollbar"
        :class="{
            'show-collapse': showCollapse,
            'show-business': !isMobile,
            collapsed: collapsed
        }"
        @click="replace && $emit('update:replace', false)"
        @mouseenter="replace && $emit('update:replace', false)"
    >
        <div class="tab-collapse" @click="collapsed = !collapsed">
            <i class="iconfont icon-expand"></i>
            <i class="iconfont icon-arrow-down"></i>
        </div>
        <div class="tab-header" v-show="!showDetail">
            <span
                v-for="tab in tabs"
                :key="tab.type"
                class="item"
                :class="[{ active: activeType === tab.type }, tab.type]"
                @click="activeType = tab.type"
            >{{ tab.label }}</span
            >
        </div>
        <div class="tab-body" v-show="!showDetail">
            <div
                v-for="tab in tabs"
                :key="tab.type"
                class="tab-content"
                :class="[{ 'more-panel': !!tab.moreLink }, tab.type]"
                v-show="activeType === tab.type"
            >
                <template v-if="tab.type === 'house'">
                    <ul v-if="tab.data" class="list">
                        <li
                            v-for="item in tab.data.slice(0, houseLimit)"
                            :key="item.id"
                            class="item"
                            :class="{
                                active:
                                    itemActiveKey ===
                                    'house-' +
                                    item.latitude +
                                    '-' +
                                    item.longitude
                            }"
                            @mouseenter="!isMobile && itemEnter('house', item)"
                            @mouseleave="itemLeave('house')"
                            @click="isMobile && itemEnter('house', item)"
                        >
                            <a
                                :href="transformLink2WordPress(item.detailLink)"
                                :target="getDetailTarget(item)"
                                rel="noopener noreferrer"
                            >
                                <p class="addr">
                                    {{ item.isShowMask ? $t('addressNotDisclosed') : item.formatAddress }}
                                </p>
                                <p
                                    v-if="item.commercialRealEstate"
                                    class="desc"
                                >
                                    <span
                                    >{{
                                        $t('md-map.sqft', {
                                            num: item.isShowMask ? '***' :
                                                (    item.sqft > -1
                                                    ? item.sqft
                                                    : '-'
                                                )
                                        })
                                    }}
                                        ·</span
                                    >
                                    <span>{{ item.lotSizeWithUnit }} ·</span>
                                    <span>{{ item.pricePerSqft }}</span>
                                </p>
                                <p v-else class="desc">
                                    <span
                                        class="vertical-line"
                                        v-if="item.bedrooms > 0"
                                    >{{ item.isShowMask ? $t('md-map.bed_one', { num : '***' }) : formatBed(item.bedrooms, 2) }}</span
                                    >
                                    <span
                                        class="vertical-line"
                                        v-if="item.bathrooms > 0"
                                    >{{
                                        item.isShowMask ? $t('md-map.bath_one', { num : '***' }) : formatBath(item.bathrooms, 2)
                                    }}</span
                                    >
                                    <span class="vertical-line">{{
                                        item.isShowMask ? $t('md-map.sqft', { num : '***' }) : formatSqft(item, 2)
                                    }}</span>
                                </p>
                                <p class="desc">
                                    {{
                                        item.propertyTypeText ||
                                            item.propertyType
                                    }}
                                </p>
                                <div class="house-mls-info">
                                    <div class="mls-info">
                                        <p
                                            v-if="
                                                item.mlsOrg.mlsOrgHas74 &&
                                                    item.mlsListingId
                                            "
                                        >
                                            MLS# {{ item.mlsListingId }}
                                        </p>
                                        <div v-if="item.provided && !item.isShowMask" v-html="item.provided"></div>
                                    </div>
                                    <div
                                        v-if="item.mlsLogo"
                                        class="house-mls-info-logo"
                                    >
                                        <site-img
                                            :src="item.mlsLogo"
                                            dir="height"
                                        ></site-img>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                    <div v-if="tab.moreLink && !wordPressSSR" class="more">
                        <a :href="tab.moreLink" rel="noopener noreferrer">{{
                            tab.moreLabel || $t('md-map.more')
                        }}</a>
                    </div>
                </template>
                <template v-else-if="tab.type === 'school'">
                    <template
                        v-for="(group, index) in tab.groups"
                        :key="group.label"
                    >
                        <div
                            class="group"
                            :class="{
                                active: schoolGroupActiveIndex === index
                            }"
                            @click="schoolGroupClick(index, group)"
                        >
                            {{ group.label }}
                            {{ group.data && group.data.length }}
                            <i class="iconfont icon-expand"></i>
                        </div>
                        <ul class="list">
                            <li
                                v-for="item in group.data"
                                :key="item.id + '-' + (item.level || '')"
                                class="item server-property"
                                :class="{
                                    active:
                                        itemActiveKey ===
                                        'school-' +
                                        item.latitude +
                                        '-' +
                                        item.longitude
                                }"
                                @mouseenter="
                                    !isMobile && itemEnter('school', item)
                                "
                                @mouseleave="itemLeave('school')"
                                @click="schoolItemClick(item)"
                            >
                                <div
                                    class="score"
                                    :class="[
                                        'score-' + item.gsRating,
                                        {
                                            high: item.gsRating > 9,
                                            middle:
                                                item.gsRating >= 6 &&
                                                item.gsRating <= 9,
                                            low:
                                                !item.gsRating ||
                                                item.gsRating < 6
                                        }
                                    ]"
                                >
                                    {{ item.gsRating || 0 }}
                                </div>
                                <p class="school-name">{{ item.name }}</p>
                                <p class="school-desc">
                                    {{ item.admission }} | {{ item.gradeLow }} -
                                    {{ item.gradeHigh }}
                                </p>
                            </li>
                        </ul>
                    </template>
                </template>
                <template v-else-if="tab.type === 'business'">
                    <template v-for="(group, index) in tab.groups" :key="index">
                        <div
                            class="group"
                            :class="{
                                active: businessGroupActiveIndex === index
                            }"
                            @click="businessGroupClick(index, group)"
                        >
                            {{ group.label }}
                            {{ group.data && group.data.length }}
                            <i class="iconfont icon-expand"></i>
                        </div>
                        <ul class="list">
                            <li
                                v-for="item in group.data"
                                :key="item.id"
                                class="item"
                                :class="{
                                    active:
                                        itemActiveKey ===
                                        'business-' +
                                        item.latitude +
                                        '-' +
                                        item.longitude
                                }"
                                @mouseenter="
                                    !isMobile && itemEnter('business', item)
                                "
                                @mouseleave="itemLeave('business')"
                                @click="isMobile && itemEnter('business', item)"
                            >
                                <p class="name">{{ item.name }}</p>
                                <p class="detail">
                                    <a
                                        v-if="item.phone"
                                        class="tel"
                                        :href="'tel:' + item.phone"
                                        target="_top"
                                        rel="noopener noreferrer"
                                    >{{ $ft.formatPhone(item.phone) }}</a
                                    >
                                    <span>{{
                                        item.categoryTertiary ||
                                            item.categorySecondary ||
                                            ''
                                    }}</span>
                                </p>
                            </li>
                        </ul>
                    </template>
                </template>
            </div>
        </div>
        <div class="detail-header" v-show="showDetail">
            <span class="to-back" @click="detailBack">
                <i class="iconfont icon-prev"></i
                >{{ $t('md-map.backToPrevious') }}</span
            >
        </div>
        <div ref="detailBody" class="detail-body" v-show="showDetail">
            <div class="school" :class="{ 'more-panel': detailData.moreLink }">
                <p class="name">{{ detailData.name }}</p>
                <ul class="table">
                    <li
                        v-for="item in detailData.table"
                        :key="item.label"
                        class="item"
                    >
                        <p class="label">{{ item.label }}</p>
                        <p class="value">{{ item.value }}</p>
                    </li>
                </ul>
                <div
                    v-for="info in detailData.info"
                    :key="info.label"
                    class="info"
                >
                    <p class="label">{{ info.label }}</p>
                    <a
                        v-if="info.label === 'Phone'"
                        class="value"
                        :href="'tel:' + info.value"
                        target="_top"
                        rel="noopener noreferrer"
                    >{{ $ft.formatPhone(info.value) }}</a
                    >
                    <p v-else-if="info.label === 'Expenditure'" class="value">
                        {{ $ft.formatCurrency({ value: info.value, noSpace:true, currencySymbol}) }}
                    </p>
                    <p v-else class="value">{{ info.value }}</p>
                </div>
                <div v-if="detailData.moreLink && !wordPressSSR" class="more">
                    <a :href="detailData.moreLink" rel="noopener noreferrer">{{
                        detailData.moreLabel ||
                            $t('md-map.viewHomesInThisSchool')
                    }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mapTab from '../map-tab';

export default {
    mixins: [mapTab]
};
</script>

<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';

.md-map.fashion {
    .map-tab {
        flex-shrink: 0;
        height: 100%;
        min-width: 360px;
        width: 0;
        position: relative;
        transition: min-width 0.3s ease;
        .tab-collapse {
            position: absolute;
            left: -22px;
            top: 50%;
            transform: translateY(-50%);
            display: none;
            .icon-expand {
                display: block;
                width: 22px;
                height: 50px;
                background-color: #2f374f;
                border-radius: 3px 0 0 3px;
                cursor: pointer;
                &:before {
                    font-size: 12px;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    color: #bfc9e4;
                    transform: translate(-50%, -50%) scale(1.5) rotate(-90deg);
                }
            }
            .icon-arrow-down {
                display: none;
            }
        }
        .tab-header {
            font-size: 16px;
            height: 66px;
            line-height: 66px;
            font-family: var(--font-medium);
            background-color: #242a3d;
            display: flex;
            padding-left: 20px;
            overflow: hidden;
            .item {
                position: relative;
                color: #bfc9e4;
                text-transform: capitalize;
                cursor: pointer;
                font-size: 12px;
                margin-right: 40px;
                &:last-of-type {
                    margin-right: 0;
                }
                &.active {
                    @include color-theme();
                    &::before {
                        position: absolute;
                        content: '';
                        width: 62px;
                        height: 3px;
                        @include color-theme('background-color');
                        transform: translateX(-50%);
                        border-radius: 2px;
                        margin-left: 0;
                        left: 50%;
                        bottom: 0;
                    }
                }
                &.business {
                    display: none;
                }
            }
        }
        .tab-body {
            position: absolute;
            top: 66px;
            bottom: 0;
            width: 100%;
            color: #fff;
            font-size: 14px;
            background-color: #2f374f;
            overflow: hidden;
            .tab-content {
                width: 100%;
                height: 100%;
                overflow: auto;
                .group {
                    line-height: 50px;
                    font-size: 14px;
                    font-family: var(--font-medium);
                    color: #fff;
                    padding-left: 20px;
                    position: relative;
                    cursor: pointer;
                    .icon-expand {
                        position: absolute;
                        right: 0;
                    }
                    + .list {
                        display: none;
                    }
                    &.active {
                        .icon-expand {
                            transform: rotate(180deg);
                        }
                        + .list {
                            display: block;
                        }
                    }
                }
                .item {
                    position: relative;
                    margin: 4px 0;
                    &:first-child {
                        margin-top: 0;
                    }
                    &:last-child {
                        margin-bottom: 0;
                    }
                }
                &.house {
                    height: calc(100% - 60px);
                    .item {
                        height: auto;
                        padding: 15px 0 0 15px;
                        margin: 0;
                        position: relative;
                        &.active {
                            background-color: #394157;
                        }
                        > a {
                            padding-bottom: 9px;
                            height: 100%;
                            display: block;
                            border-bottom: solid 1px #394157;
                        }
                        .addr {
                            font-family: var(--font-medium);
                            font-size: 14px;
                            color: #fff;
                            @include ellipsis();
                        }
                        .desc {
                            font-size: 12px;
                            color: #bfc9e4;
                            .vertical-line {
                                &:after {
                                    content: ' |';
                                }
                                &:nth-last-child(1)::after {
                                    content: '';
                                }
                            }
                        }

                        .house-mls-info {
                            width: 100%;
                            display: flex;
                            .mls-info {
                                width: 80%;
                                font-size: 12px;
                                color: #8b93a7;
                                line-height: 14px;
                                margin-top: 10px;
                                display: block;
                            }
                            .house-mls-info-logo {
                                width: 20%;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                img {
                                    max-height: 40%;
                                    max-width: 100%;
                                }
                            }
                        }
                    }
                }
                &.school {
                    .group {
                        width: 300px;
                        margin: 0 0 0 30px;
                        padding-left: 0;
                        line-height: 56px;
                        height: 44px;
                    }
                    .item {
                        height: auto;
                        position: relative;
                        padding: 11px 0 11px 30px;
                        margin: 0;
                        .score {
                            float: left;
                            width: 36px;
                            height: 36px;
                            line-height: 36px;
                            border-radius: 5px;
                            font-size: 16px;
                            text-align: center;
                            color: #fff;
                            margin-right: 10px;
                            &.high {
                                background-color: #fec200;
                            }
                            &.middle {
                                background-color: #29cb97;
                            }
                            &.low {
                                background-color: #249bff;
                            }
                        }
                        &::after {
                            content: '';
                            display: block;
                            position: absolute;
                            height: 0;
                            border-bottom: solid 1px #394157;
                            bottom: 0;
                            left: 86px;
                            right: 22px;
                        }
                        .school-name {
                            font-family: var(--font-normal);
                            font-size: 14px;
                            line-height: 16px;
                            color: #ffffff;
                            @include ellipsis();
                        }
                        .school-desc {
                            font-size: 12px;
                            line-height: 14px;
                            margin-top: 6px;
                            color: #bfc9e4;
                        }
                        &.hover,
                        &.active,
                        &:hover {
                            background-color: #394157;
                        }
                    }
                }
                &.business {
                    .group {
                        padding: 21px 0 0 0;
                        margin: 0 0 0 30px;
                        border: none;
                        width: 300px;
                        height: 48px;
                        border-bottom: solid 2px #394157;
                        font-family: var(--font-medium);
                        font-size: 14px;
                        line-height: 16px;
                        color: #ffffff;
                    }
                    .item {
                        height: 58px;
                        padding: 13px 0 0 30px;
                        margin: 0;
                        font-family: var(--font-normal);
                        cursor: pointer;
                        color: #ffffff;
                        &.active {
                            background-color: #394157;
                        }
                        .name {
                            font-size: 14px;
                            @include ellipsis();
                        }
                        .detail {
                            font-size: 12px;
                            color: #bfc9e4;
                            @include ellipsis();
                            .tel {
                                margin-right: 10px;
                            }
                        }
                    }
                }
            }
        }
        .detail-header {
            color: #fff;
            height: 66px;
            line-height: 66px;
            font-family: var(--font-medium);
            background-color: #242a3d;
            overflow: hidden;
            .to-back {
                display: inline-block;
                position: relative;
                font-size: 16px;
                font-family: var(--font-normal);
                color: #bfc9e4;
            }
            .icon-prev {
                font-size: 12px;
                width: 24px;
                height: 24px;
                line-height: 24px;
                margin: 21px 12px 8px 10px;
                display: inline-block;
                vertical-align: top;
                cursor: pointer;
                &:before {
                    font-weight: bold;
                    position: absolute;
                    width: 24px;
                    text-align: center;
                }
            }
        }
        .detail-body {
            position: absolute;
            top: 66px;
            bottom: 0;
            width: 100%;
            overflow: hidden;
            background-color: #2f374f;
            .school {
                .name {
                    margin: 20px 0 20px 30px;
                    font-size: 20px;
                    color: #ffffff;
                    line-height: 1.2;
                    position: relative;
                }
                .table {
                    height: 81px;
                    background-color: #394157;
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    .item {
                        flex-grow: 1;
                        text-align: center;
                        height: 100%;
                        padding: 18px 0 0 0;
                        .label {
                            color: #bfc9e4;
                            font-size: 12px;
                            line-height: 1.83;
                        }
                        .value {
                            font-family: var(--font-bold);
                            font-size: 14px;
                            line-height: 1.43;
                            letter-spacing: 0.8px;
                            color: #ffffff;
                        }
                    }
                }
                .info {
                    padding: 10px 0 10px 30px;
                    &:first-child {
                        padding-top: 30px;
                    }
                    .label {
                        margin-bottom: 4px;
                        font-size: 14px;
                        color: #ffffff;
                    }
                    .value {
                        font-size: 12px;
                        color: #bfc9e4;
                    }
                }
                .more {
                    position: absolute;
                    bottom: 20px;
                    width: 100%;
                    @include color-theme();
                    text-align: center;
                    text-decoration: underline;
                    font-size: 14px;
                    font-family: var(--font-medium);
                }
            }
        }
        .more-panel {
            padding-bottom: 0;
            .more {
                position: absolute;
                width: 100%;
                font-size: 14px;
                height: 60px;
                line-height: 60px;
                bottom: 0;
                background-color: #2f374f;
                text-align: center;
                text-decoration: underline;
                a {
                    @include color-theme();
                    text-decoration: none;
                }
            }
        }
        &.show-business {
            .tab-header {
                .item.business {
                    display: inline-block;
                }
            }
        }
        &.collapsed {
            min-width: 0;
            .tab-collapse {
                .icon-expand {
                    &:before {
                        color: #fff;
                        transform: translate(-50%, -50%) scale(1.5)
                            rotate(90deg);
                    }
                }
            }
        }
        &.show-collapse {
            .tab-collapse {
                display: block;
            }
        }
    }
    @include media-600 {
        .map-tab {
            background-color: #fff;
            width: 100%;
            min-width: auto;
            height: initial;
            user-select: none;
            position: static;
            .tab-header {
                width: auto;
                height: 49px;
                line-height: 49px;
                .item {
                    max-width: 50%;
                }
            }
            .tab-body {
                position: relative;
                top: 0;
                bottom: initial;
                border: none;
                .tab-content {
                    &.school {
                        padding-bottom: 30px;
                        .group {
                            width: auto;
                            padding: 0;
                            margin: 0 15px;
                            border-bottom: 1px solid #394157;
                            &:last-child {
                                border: none;
                            }
                            > .iconfont {
                                height: 100%;
                                right: 0;
                            }
                        }
                        .item {
                            padding-left: 15px;
                            height: 60px;
                            .score {
                                margin-right: 10px;
                            }
                            &::after {
                                left: 61px;
                            }
                        }
                    }
                    &.house {
                        .item {
                            padding-left: 15px;
                            padding-top: 6px;
                            .desc:last-child {
                                color: #8b93a7;
                            }
                        }
                        .more {
                            position: relative;
                        }
                    }
                    &.business {
                        padding-bottom: 30px;
                        .group {
                            margin: 0 15px;
                            width: auto;
                            > .iconfont {
                                right: 0;
                            }
                        }
                        .item {
                            padding: 10px 0 0 15px;
                            height: 60px;
                        }
                    }
                }
            }
            .detail-header {
                height: 49px;
                line-height: 49px;
                .icon-prev {
                    margin: 12px 10px 0 12px;
                }
            }
            .detail-body {
                position: relative;
                top: 0;
                bottom: initial;
                border: none;
                padding-bottom: 30px;
                .school {
                    .name {
                        margin: 0;
                        padding: 20px 0 20px 15px;
                    }
                    .info {
                        width: 50%;
                        display: inline-block;
                        padding: 0 0 0 20px;
                        margin: 30px 0 0 0;
                        vertical-align: top;
                    }
                    .more {
                        position: static;
                        margin-top: 30px;
                        background-color: #2f374f;
                        line-height: 30px;
                        font-size: 12px;
                        transform: translateY(10px);
                    }
                }
            }
            .more-panel {
                padding-bottom: 0;
                position: relative;
            }
            &.show-collapse {
                position: relative;
                .tab-collapse {
                    display: none;
                }
                .tab-header,
                .tab-body {
                    display: flex;
                }
                &.collapsed {
                    margin-bottom: 30px;
                    .tab-collapse {
                        display: block;
                        left: 50%;
                        top: initial;
                        bottom: -40px;
                        transform: translate(-50%, -50%);
                        @include color-theme();
                        &:before {
                            content: 'MORE';
                            font-size: 14px;
                        }
                        .icon-expand {
                            display: none;
                        }
                        .icon-arrow-down {
                            display: inline-block;
                            position: relative;
                            margin-left: 10px;
                            width: auto;
                            height: 8px;
                            &:before {
                                @include color-theme();
                                transform: translate(-50%, -50%) scale(0.8)
                                    rotate(0deg);
                            }
                        }
                    }
                    .tab-header,
                    .tab-body {
                        display: none;
                    }
                }
            }
        }
    }
}
</style>
